import { configureStore } from "@reduxjs/toolkit";
import bookSameDaySlice from "./Slice/bookSameDaySlice";
import cleaningSameDaySlice from "./Slice/cleaningSameDaySlice";
import contractorRegisterSlice from "./Slice/contractorRegisterSlice";
import companyDetailSlice from "./Slice/companyDetailSlice";
import pageDescriptionSlice from "./Slice/pageDescriptionSlice";
import socialDetailSlice from "./Slice/socialDetailSlice";
import metaDetailsSlice from "./Slice/metaDetailsSlice";
import homeBannerDetailSlice from "./Slice/homeBannerDetailSlice";
import servicesDetailSlice from "./Slice/servicesDetailSlice";
import faqDetailSlice from "./Slice/faqDetailSlice";
import reviewDetailSlice from "./Slice/reviewDetailSlice";
import residenceTypeSlice from "./Slice/residenceTypeSlice";
import cityListSlice from "./Slice/CityListingSlice";
import cleaningExpListSlice from "./Slice/cleaningExpListSlice";
import bookNowDetailSlice from "./Slice/bookNowDetailSlice";
import extrasDetailSlice from "./Slice/extrasDetailSlice";
import customerRegisterSlice from "./Slice/customerRegisterSlice";
import loginSlice from "./Slice/loginSlice";
import forgetPasswordSlice from "./Slice/forgetPasswordSlice";
import resetPasswordSlice from "./Slice/resetPasswordSlice";
import paymentAuthorizationSlice from "./Slice/paymentAuthorizationSlice";
import labelDetailSlice from "./Slice/labelDetailSlice";
import contactDetailSlice from "./Slice/contactDetailSlice";
import blogListingSlice from "./Slice/blogListingSlice";
import blogDetailSlice from "./Slice/blogDetailSlice";
import blogCategoryListingSlice from "./Slice/blogCategoryListingSlice";
import tagListingSlice from "./Slice/tagListingSlice";
import commentListingSlice from "./Slice/commentListingSlice";
import addCommentSlice from "./Slice/addCommentSlice";
import customerBookingSlice from "./Slice/customerBookingSlice";
import customerProfileSlice from "./Slice/customerProfileSlice";
import contractorJobListingSlice from "./Slice/contractorJobListingSlice";
import promoCodeListingSlice from "./Slice/promoCodeListingSlice";
import customerUpdateProfileSlice from "./Slice/customerUpdateProfileSlice";
import customerReviewSlice from "./Slice/customerReviewSlice";
import contractorProfileSlice from "./Slice/contractorProfileSlice";
import contractorReviewSlice from "./Slice/contractorReviewSlice";
import contractorProfileUpdateSlice from "./Slice/contractorProfileUpdateSlice";
import customerAddressSlice from "./Slice/customerAddressSlice";
import customerAddressDeleteSlice from "./Slice/customerAddressDeleteSlice";
import customerAddAddressSlice from "./Slice/customerAddAddressSlice";
import customerAddressGetByIdSlice from "./Slice/customerAddressGetByIdSlice";
import customerAddressEditByIdSlice from "./Slice/customerAddressEditByIdSlice";
import acceptJobSlice from "./Slice/acceptJobSlice";
import rejectJobSlice from "./Slice/rejectJobSlice";
import contractorAssignBookingSlice from "./Slice/contractorAssignBookingSlice";
import notificationSlice from "./Slice/notificationSlice";
import cancelledBookingSlice from "./Slice/cancelledBookingSlice";
import startJobSlice from "./Slice/startJobSlice";
import finishJobSlice from "./Slice/finishJobSlice";
import addReviewSlice from "./Slice/addReviewSlice";
import pageNotFoundSlice from "./Slice/pageNotFoundSlice";
// import invoiceDetailSlice from "./Slice/invoiceDetailSlice";
import notificationUpdateSlice from "./Slice/notificationUpdateSlice";
import dashboardNotificationSlice from "./Slice/dashboardNotificationSlice";
import dashboardCustomerCountSlice from "./Slice/dashboardCustomerCountSlice";
import dashboardContractorCountSlice from "./Slice/dashboardContractorCountSlice";

//seo page
import seoPageSlice from "./Slice/seoPageSlice"; 

export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  reducer: {
    bookSameDayList: bookSameDaySlice,
    cleaningSameDayList: cleaningSameDaySlice,
    contractorRegisterList: contractorRegisterSlice,
    companyDetailList: companyDetailSlice,
    pageDescriptionList: pageDescriptionSlice,
    socialDetailList: socialDetailSlice,
    metaDetailList: metaDetailsSlice,
    homeBannerDetailList: homeBannerDetailSlice,
    servicesDetailList: servicesDetailSlice,
    faqDetailList: faqDetailSlice,
    reviewDetailList: reviewDetailSlice,
    residenceTypeList: residenceTypeSlice,
    cityListing: cityListSlice,
    cleaningExpList: cleaningExpListSlice,
    bookNowDetailList: bookNowDetailSlice,
    extrasDetailList: extrasDetailSlice,
    customerRegisterList: customerRegisterSlice,
    loginList: loginSlice,
    forgetPasswordList: forgetPasswordSlice,
    resetPasswordList: resetPasswordSlice,
    paymentAuthorizationList: paymentAuthorizationSlice,
    labelDetailList: labelDetailSlice,
    contactDetailList: contactDetailSlice,
    blogListing: blogListingSlice,
    blogDetailById: blogDetailSlice,
    blogCategoryListing: blogCategoryListingSlice,
    tagListing: tagListingSlice,
    commentListing: commentListingSlice,
    addCommentList: addCommentSlice,
    customerBookingList: customerBookingSlice,
    customerProfileDetail: customerProfileSlice,
    contractorJobList: contractorJobListingSlice,
    promoCodeList: promoCodeListingSlice,
    customerUpdateProfile: customerUpdateProfileSlice,
    customerReviewList: customerReviewSlice,
    contractorProfileDetail: contractorProfileSlice,
    contractorReviewList: contractorReviewSlice,
    contractorUpdateProfile: contractorProfileUpdateSlice,
    customerAddressList: customerAddressSlice,
    customerAddressDeleteList: customerAddressDeleteSlice,
    customerAddressAddList: customerAddAddressSlice,
    customerAddressByIdList: customerAddressGetByIdSlice,
    customerAddressEditByIdList: customerAddressEditByIdSlice,
    acceptJobList: acceptJobSlice,
    rejectJobList: rejectJobSlice,
    contractorAssignBookingList: contractorAssignBookingSlice,
    notificationList: notificationSlice,
    cancelledBookingList: cancelledBookingSlice,
    startJobList: startJobSlice,
    finishJobList: finishJobSlice,
    addReviewList: addReviewSlice,
    pageNotFound: pageNotFoundSlice,
    // invoiceDetailList: invoiceDetailSlice,
    notificationUpdateList: notificationUpdateSlice,
    dashboardNotificationList: dashboardNotificationSlice,
    dashboardCustomerCountList: dashboardCustomerCountSlice,
    dashboardContractorCountList:dashboardContractorCountSlice,
    seoPage: seoPageSlice,
  },
});
